import {Box} from 'platform/foundation';

import {mergeAll} from 'ramda';

import {
  DOCUMENT_ACTION_COLUMNS,
  useGetDocumentDatagridActions,
} from '@dms/features/document-context';
import {DmsDataGrid, refreshDmsDatagrid} from '@dms/shared';

import type {QueryFilterObject} from 'features/eag-grid';

interface VehicleWarehouseOperationsCardProps {
  vehicleId: string;
  saleVehicleId: string;
}

export function VehicleWarehouseOperationsCard(props: VehicleWarehouseOperationsCardProps) {
  const refreshDataGrid = () => refreshDmsDatagrid('sale_vehicle_warehouse_movement');

  const [actionCallback] = useGetDocumentDatagridActions({
    contextId: props.vehicleId,
    contextTarget: 'vehicle',
    refreshData: refreshDataGrid,
  });

  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {saleVehicle: [props.saleVehicleId]}]);

  return (
    <Box minHeight={40}>
      <DmsDataGrid
        gridCode="sale_vehicle_warehouse_movement"
        autoHeight
        actionCallback={actionCallback}
        predefinedColumns={DOCUMENT_ACTION_COLUMNS}
        queryModifier={queryModifier}
        data-testid="warehouse-movement-datagrid"
      />
    </Box>
  );
}
